module.exports = __webpack_public_path__ + "media/images/flags/32/Republic-of-the-Congo-d8147a752d8e16a5d6ee932f597eef99.png";